import React from 'react';
import { MdErrorOutline } from 'react-icons/md';
import { RootStyled } from './notFound.styles';

export default function NotFound() {
  return (
    <RootStyled>
      <MdErrorOutline />
      <h1>Page not found</h1>
    </RootStyled>
  );
}
